import httpService from "services/api.service";

const BASE_URL = "/stock_opname";

export const getStockOpname = async (payload) => {
  try {
    const res = await httpService.get(BASE_URL, { params: payload });
    return res;
  } catch (error) {
    throw error.response.data.msg;
  }
};

export const createStockOpname = async (payload) => {
  try {
    const res = await httpService.post(BASE_URL, payload);

    return res;
  } catch (error) {
    throw error.response.data.msg;
  }
};

export const updateStockOpname = async (payload) => {
  try {
    const res = await httpService.put(BASE_URL, payload);

    return res;
  } catch (error) {
    throw error.response.data.msg;
  }
};
